import * as globalStyles from 'styles/style.scss';
import { CellClassParams, ValueFormatterParams } from 'ag-grid-community';
import { IColDef, IColGroupDef } from 'interfaces/common';
import {
  IDebtMarginResponse,
  IEquityConfirmDebtResponse,
} from 'interfaces/api';
import { formatNumber } from 'utils/common';
import { formatTimeToDisplay } from 'utils/datetime';
import i18next from 'i18next';

export const debtMarginInfor = (): Array<
  IColGroupDef<IDebtMarginResponse> | IColDef<IDebtMarginResponse>
> => [
  {
    headerName: i18next.t('Month'),
    field: 'month',
    headerClass: globalStyles.Header,
    cellClass: `${globalStyles.Cell} text-center`
  },
  {
    headerName: i18next.t('Lending Amount2'),
    field: 'lendingAmount',
    headerClass: globalStyles.Header,
    cellClass: `${globalStyles.Cell}`,
    valueFormatter: (params: ValueFormatterParams) =>
      formatNumber(
        params.data?.lendingAmount,
        2,
        undefined,
        false,
        '—'
      ),
  },
  {
    headerName: i18next.t('Interest Amount'),
    field: 'interestAmount',
    headerClass: globalStyles.Header,
    cellClass: globalStyles.Cell,
    valueFormatter: (params: ValueFormatterParams) =>
      formatNumber(
        params.data?.interestAmount,
        2,
        undefined,
        false,
        '—'
      ),
  },
  // {
  //   headerName: i18next.t('Pay Amount In Month'),
  //   field: 'payAmtInMonth',
  //   headerClass: globalStyles.Header,
  //   cellClass: globalStyles.Cell,
  //   valueFormatter: (params: ValueFormatterParams) =>
  //     formatNumber(
  //       params.data?.payAmtInMonth,
  //       2,
  //       undefined,
  //       false,
  //       '—'
  //     ),
  // },
  // {
  //   headerName: i18next.t('Total Loan3'),
  //   field: 'totalLoan',
  //   headerClass: globalStyles.Header,
  //   cellClass: globalStyles.Cell,
  //   minWidth: 280,
  //   valueFormatter: (params: ValueFormatterParams) =>
  //     formatNumber(
  //       params.data?.totalLoan,
  //       2,
  //       undefined,
  //       false,
  //       '—'
  //     ),
  // },
];

export const debtConfirmationHistory = (): Array<
  IColGroupDef<IEquityConfirmDebtResponse> | IColDef<IEquityConfirmDebtResponse>
> => [
  {
    headerName: i18next.t('Month'),
    field: 'month',
    headerClass: globalStyles.Header,
    cellClass: `${globalStyles.Cell}`,
    cellClassRules: {
      ['text-center']: (params: CellClassParams) => {
        return params.data.no !== 'TOTAL';
      },
    },
  },
  {
    headerName: i18next.t('Signed Date'),
    field: 'dateConfirm',
    valueFormatter: (params: ValueFormatterParams) =>
      formatTimeToDisplay(params.value, 'dd/MM/yyyy', 'yyyyMMddHHmmss', true) ||
      '',
    headerClass: globalStyles.Header,
    cellClass: `${globalStyles.Cell} text-center`,
  },
  {
    headerName: i18next.t('Lending Amount'),
    field: 'lendingAmount',
    valueFormatter: (params: ValueFormatterParams) =>
      formatNumber(
        params.data?.lendingAmount,
        2,
        undefined,
        false,
        '—'
      ),
    headerClass: globalStyles.Header,
    cellClass: globalStyles.Cell,
  },
  {
    headerName: i18next.t('Interest Amount'),
    field: 'interestAmount',
    headerClass: globalStyles.Header,
    cellClass: globalStyles.Cell,
    valueFormatter: (params: ValueFormatterParams) =>
      formatNumber(
        params.data?.interestAmount,
        2,
        undefined,
        false,
        '—'
      ),
  },
];



// WEBPACK FOOTER //
// ./src/components/areas/Account/LoadDetail/ConfirmDebt/config.ts